import { InjectionToken } from '@angular/core';
import { CaptchaSettings } from './captcha-settings.interface';

export let CAPTCHA_SETTINGS = new InjectionToken<CaptchaSettings>('captcha.settings');



// WEBPACK FOOTER //
// ./src/app/angular-captcha/src/config.ts